import {Step} from '../Step/Step'
import {MaximizedGuests} from './MaximizedGuests'
import {MinimizedGuests} from './MinimizedGuests'

export const Guests = () => {
  return (
    <Step
      title="Guests"
      caption="Who's joining?"
      thisStepCode="guests"
      minimizedComponent={MinimizedGuests}
      maximizedComponent={MaximizedGuests}
    />
  )
}
